var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckdocumentos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #04808f;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.2,
    y: 2.81,
    width: 19.6,
    height: 24.75,
    rx: 4.27,
    ry: 4.27,
    transform: "translate(-.19 30.19) rotate(-90)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.75,11.77c.09-.12,.14-.27,.13-.42-.01-.15-.08-.29-.2-.39-.11-.1-.26-.16-.41-.15-.15,0-.3,.07-.4,.17l-5.95,6.66-1.71-2.51c-.04-.07-.1-.12-.16-.16s-.14-.07-.22-.09c-.04,0-.07-.01-.11-.01-.14,0-.27,.05-.38,.14-.11,.09-.18,.21-.2,.34-.02,.08-.01,.15,0,.23,.02,.08,.05,.15,.09,.21l2.13,3.15c.05,.07,.12,.14,.2,.18,.08,.05,.17,.07,.26,.08h.04c.08,0,.17-.02,.24-.05,.08-.03,.14-.08,.2-.15l6.46-7.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckdocumentos);
export default __webpack_public_path__ + "static/media/Checkdocumentos.525196b5cd0c3266f9bfd440ada4fb81.svg";
export { ForwardRef as ReactComponent };